import ProductDetailPage from '../components/products/ProductDetailPage';
import { getProductPageConfig } from '../data/products/productsRegistry';

const SoapStiffenerPaper = () => <ProductDetailPage {...getProductPageConfig('soapStiffenerPaper')} />;

export default SoapStiffenerPaper;
